import ReactApexChart from "react-apexcharts";
import CountUp from "react-countup";
import { Card, CardBody, CardHeader, Col } from "reactstrap";
import { H4, Image, LI, ProgressBar, UL } from "../../../../AbstractElements";
import { OnlineSalesCardBodyData, OnlineSalesCardData } from "../../../../Data/General/Dashboard/Ecommerce";
import SvgIcon from "../../../CommonComponents/SvgIcon/SvgIcon";
import { dynamicImage } from "../../../../Utils";
import { Fragment } from "react/jsx-runtime";

const OnlineSalesCard = () => {
  return (
    <Fragment>
      {OnlineSalesCardData.map((item, index) => (
        <Col xxl="2" lg="3" md="4" sm="6" className="box-col-3" key={index}>
          <Card className="online-order">
            <CardHeader className="pb-0">
              <div className="d-flex">
                <div className={`order bg-light-${item.color}`}>
                  <SvgIcon iconId={item.icon} />
                </div>
                <div className="arrow-chart">
                  <SvgIcon iconId={item.arrowChart} />
                  <span className={`font-${item.arrowColor}`}>{item.text}</span>
                </div>
              </div>
              <div className="online">
                <span>{item.title}</span>
                <H4><CountUp end={item.endValue} className="num-counter" delay={0} /></H4>
              </div>
            </CardHeader>
            {item.chart ? (
              <CardBody className="pt-0 ps-2 pe-2">
                <div id="online-chart" className={item.chartClass}>
                  <ReactApexChart options={item.chart} series={item.chart.series} height={item.chart.chart?.height} type={item.chart.chart?.type} />
                </div>
              </CardBody>
            ) : (
              <CardBody>
                <div className="user-details customers">
                  <UL className="simple-list">
                    {OnlineSalesCardBodyData.map((item, index) => (
                      <LI className="d-inline-block" key={index}>
                        <Image className="rounded-circle" src={dynamicImage(`dashboard-2/user/${item}`)} alt="user" />
                      </LI>
                    ))}
                  </UL>
                </div>
                <ProgressBar color="warning" value={50} />
              </CardBody>
            )}
          </Card>
        </Col>
      ))}
    </Fragment>
  );
};

export default OnlineSalesCard;
